import React from 'react';
import './style/errorPage.scss';
import { Button } from '@material-ui/core';
import pagenotfount from '../assets/images/pussyCat.png';

function refreshPage() {
  window.location.reload();
}

function ErrorRenderPage() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        padding: '10em 0',
      }}
    >
      <img src={pagenotfount} style={{ width: '230px' }} />
      <p style={{ fontWeight: '500', fontSize: '24px', textAlign: 'center', lineHeight: '32px', margin: '10px 0 1em 0px' }}>
        Sorry, An unexpected error occured. <br />
        Please try after sometime.
      </p>
      <div className="card-action">
        <Button
          href="/stores"
          className="adPrimaryButton waves-effect waves-green"
          style={{ marginRight: '10px', display: 'inline-block', boxShadow: 'none', height: '42px', lineHeight: '22px' }}
        >
          Go to All Store
        </Button>
        <Button
          onClick={refreshPage}
          className="aisleSecondarycanelButton waves-effect waves-green"
          style={{ marginLeft: '10px', display: 'inline-block' }}
        >
          Refresh Page
        </Button>
      </div>
    </div>
  );
}

export default ErrorRenderPage;
